/* unplugin-vue-components disabled */import { render } from "./Major.vue?vue&type=template&id=46b3833f&scoped=true"
import script from "./Major.vue?vue&type=script&lang=js"
export * from "./Major.vue?vue&type=script&lang=js"

import "./Major.vue?vue&type=style&index=0&id=46b3833f&lang=css"
import "./Major.vue?vue&type=style&index=1&id=46b3833f&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b3833f"]])

export default __exports__